import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { DropDownList } from '@progress/kendo-react-dropdowns';

import { useAuth0 } from '../auth';
import { getClients } from './navigation.actions';
import * as selectors from './navigation.selectors';

const ClientDropdownComponent = ({clients, onComponentMount, onSelect, selectedClient}) => {

    const [selectedValue, setSelectedValue] = useState(selectedClient);
    const { getTokenSilently } = useAuth0();

    const handleValueChange = (event) => {
        const selectedClient = event.target.value;
        setSelectedValue(selectedClient);
        onSelect(selectedClient);
    };

    useEffect(() => {
        const notifyComponentMount = async() => {
            const token = await getTokenSilently();
            onComponentMount(token);
        };
        notifyComponentMount();
    }, [getTokenSilently, onComponentMount]);

    return (
        <div className="client-box-container">
            <DropDownList data={clients}
                        textField="name" dataItemKey="id"
                        value={selectedValue} onChange={handleValueChange}/>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        clients: selectors.getClients(state)
    };
};

const mapDispatchToProps = (dispatch) => {
    const props = {
        onComponentMount: (token) => dispatch(getClients(token))
    };
    return props;
};

const ClientDropdown = connect(mapStateToProps, mapDispatchToProps)(ClientDropdownComponent);
export default ClientDropdown;